export function findClosestEquivalence(
  equivalences: Array<any>,
  targetQuantity: number
) {
  return equivalences?.reduce((closest, item) => {
    const itemQuantity = Number(item.quantity);
    const closestQuantity = Number(closest.quantity);

    return Math.abs(itemQuantity - targetQuantity) <
      Math.abs(closestQuantity - targetQuantity)
      ? item
      : closest;
  });
}

export type Equivalence = {
  quantity: number;
  portion?: string;
  portionEs?: string;
  portionEn?: string;
  portionPt?: string;
};
